export const actionTypes = {
  GET_ITEMS: 'items/getItems',
  ADD_ITEM: 'items/addItem',
  DELETE_ITEM: 'items/deleteItem',
  ADD_UNIT: 'items/addUnit',
  SUBTRACT_UNIT: 'items/subtractUnit'
};
